<template>
  <v-list-item class="pa-1 mb-1 armario-item">
    <v-sheet
      elevation="1"
      class="pa-2 rounded"
      :class="{ 'selected-armario': subarmarioSeleccionado?.id === armario.id }"
    >
      <v-row align="center" class="mb-1">
        <v-col cols="auto" class="d-flex align-center">
          <v-icon class="mr-2" size="20">mdi-wardrobe</v-icon>
          <span class="font-weight-medium text-caption">{{ armario.name }}</span>
        </v-col>
      </v-row>

      <v-row align="center" justify="start" class="gap-2">
        <!-- Adjuntar archivo -->
        <v-col cols="auto" class="pa-0">
          <v-btn icon density="compact" @click="triggerFileInput" :title="'Adjuntar archivo a ' + armario.name">
            <v-icon size="20" color="blue darken-2">mdi-paperclip</v-icon>
          </v-btn>
          <input
            type="file"
            :ref="'fileInput_' + armario.id"
            class="d-none"
            @change="handleFileUpload($event, armario.id)"
          />
        </v-col>

        <!-- Ver adjuntos con badge de cantidad -->
        <v-col cols="auto" class="pa-0">
          <v-badge
            :content="armario.adjuntos_count"
            color="red"
            overlap
            v-if="armario.adjuntos_count > 0"
          >
            <v-btn icon density="compact" @click="$emit('ver-adjuntos', armario.id)" :title="'Ver archivos de ' + armario.name">
              <v-icon size="20" color="primary">mdi-eye</v-icon>
            </v-btn>
          </v-badge>
          <v-btn
            v-else
            icon
            density="compact"
            @click="$emit('ver-adjuntos', armario.id)"
            :title="'Ver archivos de ' + armario.name"
          >
            <v-icon size="20" color="primary">mdi-eye</v-icon>
          </v-btn>
        </v-col>

        <!-- Eliminar subarmario -->
        <v-col cols="auto" class="pa-0">
          <v-btn icon density="compact" v-if="isRamos() || isDeveloper()" @click="editarSubarmario(armario)" :title="'Editar subarmario ' + armario.name">
            <v-icon size="20" color="primary">mdi-pencil</v-icon>
          </v-btn>
        </v-col>

        <!-- Eliminar subarmario -->
        <!-- <v-col cols="auto" class="pa-0">
          <v-btn icon density="compact" v-if="isRamos() || isDeveloper()" @click="eliminarSubarmario(armario)" :title="'Eliminar subarmario ' + armario.name">
            <v-icon size="20" color="primary">mdi-delete</v-icon>
          </v-btn>
        </v-col> -->

        <!-- Crear subarmario -->
        <!-- <v-col cols="auto" class="pa-0">
          <v-btn icon density="compact" v-if="isRamos() || isDeveloper()" @click="mostrarFormulario = !mostrarFormulario" :title="'Crear subarmario en ' + armario.name">
            <v-icon size="20" color="primary">{{ mostrarFormulario ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
          </v-btn>
        </v-col> -->

        <!-- Mostrar/ocultar hijos -->
        <v-col cols="auto" class="pa-0" v-if="armario.children && armario.children.length > 0">
          <v-btn icon density="compact" @click="toggleMostrarChildren" :title="'Mostrar subarmarios de ' + armario.name">
            <v-icon size="20" color="primary">{{ mostrarChildren ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- Formulario crear subarmario -->
    <div v-if="mostrarFormulario" class="mt-2">
      <v-form @submit.prevent="crearSubarmario" class="d-flex align-center gap">
        <v-text-field
          v-model="nuevoNombre"
          label="Nombre del subarmario"
          dense
          outlined
          hide-details
          required
          class="subarmario-input"
        ></v-text-field>
        <v-btn color="primary" type="submit" small>Crear</v-btn>
      </v-form>
    </div>

    <!-- Subarmarios hijos -->
    <v-list
      v-if="armario.children && armario.children.length && mostrarChildren"
      dense
      class="subarmarios-list-vertical"
    >
      <ArmarioItem
        v-for="sub in armario.children"
        :key="sub.id"
        :armario="sub"
        :adjuntosVisibles="adjuntosVisibles"
        :adjuntosPorArmario="adjuntosPorArmario"
        :recorrido="recorrido"
        :subarmarioSeleccionado="subarmarioSeleccionado"
        @ver-adjuntos="$emit('ver-adjuntos', $event)"
        @mostrar-pdf="$emit('mostrar-pdf', $event)"
        @subarmario-creado="recargar"
        @eliminar-subarmario="$emit('eliminar-subarmario', $event)"
        @editar-subarmario="$emit('editar-subarmario', $event)"
      />
    </v-list>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ArmarioItem',
  props: {
    armario: Object,
    adjuntosVisibles: Object,
    adjuntosPorArmario: Object,
    subarmarioSeleccionado: Object,
    recorrido: Array,
  },
  data() {
    return {
      nuevoNombre: '',
      mostrarFormulario: false,
      mostrarChildren: false,
    }
  },
  watch: {
    recorrido(){
      // console.log(this.recorrido);
      this.mostrarChildren = this.recorrido.some((armario_recorrido) => armario_recorrido.id == this.armario.id)
      // console.log(this.armario.name, this.mostrarChildren);
    }
  },
  mounted(){
    this.mostrarChildren = this.recorrido?.some((armario_recorrido) => armario_recorrido.id == this.armario.id)
    // console.log(this.armario.name, this.mostrarChildren);
  },
  methods: {
    ...mapGetters(["isDeveloper", "isRamos"]),
    toggleMostrarChildren() {
      this.mostrarChildren = !this.mostrarChildren
      this.$emit('seleccionar-principal', this.armario.id, this.mostrarChildren)
    },
    triggerFileInput() {
      this.$refs[`fileInput_${this.armario.id}`].click()
    },
    async handleFileUpload(event, idArmario) {
      const file = event.target.files[0]
      if (!file) return
      const reader = new FileReader()

      reader.onload = async () => {
        const base64String = reader.result.split(',')[1]
        const payload = {
          id_armario: idArmario,
          fileBase64: base64String,
          fileName: file.name,
          mimeType: file.type
        }
        await this.$store.dispatch('postData', { path: `armarios/${idArmario}/adjuntos`, body: payload })
        this.$emit('subarmario-creado')
        this.$nextTick(() => event.target.value = '')
      }

      reader.readAsDataURL(file)
    },
    async crearSubarmario() {
      if (!this.nuevoNombre.trim()) return
      const payload = {
        name: this.nuevoNombre.trim(),
        id_parent: this.armario.id,
      }
      await this.$store.dispatch('postData', { path: 'armarios', body: payload })
      this.nuevoNombre = ''
      this.$emit('subarmario-creado')
    },
    recargar() {
      this.$emit('subarmario-creado')
    },
    eliminarSubarmario(armario){
      this.$emit('eliminar-subarmario', armario);
    },
    editarSubarmario(armario){
      this.$emit('editar-subarmario', armario);
    },
  }
}
</script>

<style scoped>
.gap {
  gap: 0.3rem;
}
.armario-item {
  border-left: 1px solid #ccc;
}
.subarmarios-list-vertical {
  max-height: none;
  overflow: visible;
  padding-left: 0.5rem;
  border-left: none;
}
.subarmario-input {
  max-width: 250px;
}
.selected-armario {
  background-color: #e3f2fd !important; /* azul claro o el color que prefieras */
  border: 2px solid #2196f3;            /* opcional: un borde para resaltarlo */
}
</style>
